<template>
  <section class="vehicle-page-specifications">
    <div class="vehicle-page-specifications__container">
      <div class="vehicle-page-specifications__card">
        <h2 class="vehicle-page-specifications__title">{{ title }}</h2>
        <div class="vehicle-page-specifications__cols">
          <div class="vehicle-page-specifications__column">
            <div
              v-for="(item, index) in leftItems"
              :key="'left-' + index"
              class="vehicle-page-specifications__item"
              :class="{ 'vehicle-page-specifications__item--last': index === leftItems.length - 1 && rightItems.length === 0 }"
            >
              <span class="vehicle-page-specifications__label">{{ item.label }}</span>
              <span class="vehicle-page-specifications__value">{{ item.value }}</span>
            </div>
          </div>
          <div class="vehicle-page-specifications__column">
            <div
              v-for="(item, index) in rightItems"
              :key="'right-' + index"
              class="vehicle-page-specifications__item"
              :class="{ 'vehicle-page-specifications__item--last-v2': index === rightItems.length - 1 }"
            >
              <span class="vehicle-page-specifications__label">{{ item.label }}</span>
              <span class="vehicle-page-specifications__value">{{ item.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const SPEC_LABELS = {
  catalogYear: 'Catalog Year',
  vehicleCategory: 'Category',
  vehicleBodystyle: 'Body Style',
  vehicleDrivetrain: 'Drive Type',
  vehicleTransmissiongroup: 'Transmission',
  vehicleTransmission: 'Transmission Type',
  ancapRating: 'Safety Rating',
  vehicleFueltype: 'Fuel Type',
  vehiclePrimaryfueltype: 'Primary Fuel Type',
  vehicleDrivetrain: 'Drive Type',
  fuelConsumption: 'Fuel Consumption',
  tankCapacity: 'Tank Capacity',
  coEmission: 'CO2 Emission',
  maxLoad: 'Max Load',
  trailerLoadBraked: 'Trailer Load Braked',
  serviceSchedule: 'Vehicle Maintenance',
  engineKw: 'Engine - KW',
  engineCc: 'Engine - CC',
  vehicleNrofcylinders: 'No of Cylinders',
  vehicleWarranty: 'Vehicle Warranty',
  vehicleNrofdoors: 'No of Doors',
  vehicleNrofpassengers: 'No of Passengers'
};

export default {
  name: 'VehiclePageSpecifications',
  props: {
    title: {
      type: String,
      default: 'Car specifications'
    },
    /** Ratebook item; specs built from whatever fields are present */
    item: {
      type: Object,
      default: null
    }
  },
  computed: {
    items() {
      const i = this.item;
      if (!i) return [];
      return Object.entries(SPEC_LABELS)
        .filter(([key]) => i[key] != null && i[key] !== '')
        .map(([key, label]) => ({
          label: label.endsWith(':') ? label : `${label}:`,
          value: String(i[key])
        }));
    },
    mid() {
      return Math.ceil(this.items.length / 2);
    },
    leftItems() {
      return this.items.slice(0, this.mid);
    },
    rightItems() {
      return this.items.slice(this.mid);
    }
  }
};
</script>
